export const DownloadIcon = ({ stroke = "white" }) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 3L8 10M8 10L11 6.8M8 10L5 6.8"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M4 13H12" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
		</svg>
	);
};
